import React, { RefObject, useState } from "react";
import { IHeaderParams } from "ag-grid-community";
import {
  Checkbox,
  Dropdown,
  Icon,
  IconButton,
  Slider,
  SliderChangeCommittedCallbackType,
} from "cfa-react-components";
import Select from "react-select";
import riskSelectIcon from "../../../assets/icons/risk-score-set-all.png";

const riskScoreHeaderComponent = (
  params: IHeaderParams & {
    onSelectRiskScoreClick: (params: any) => void;
    parentNode: any;
    gridRef: RefObject<any>;
  }
) => {
  const handleClick = (event: { target: any }) => {
    params.onSelectRiskScoreClick(params);
  };
  return (
    <div>
      <text
        style={{
          transform: "translateY(-20%)",
          display: "inline-block",
          paddingRight: 10,
          justifyContent: "center",
        }}
      >
        Risk Score
      </text>
      <img
        src={riskSelectIcon}
        alt="Select All"
        onClick={handleClick}
        style={{
          display: "inline-block",
          height: "20px",
          width: "20px",
          cursor: "pointer",
        }}
      />
    </div>
  );
};

export default riskScoreHeaderComponent;
